import { createTheme } from "@mui/material/styles";

import palette from "./palette";
import typography from "./typography";
import componentOverrides from "./components";

export { BRAND_RULE, BRAND_RGB, ACCENT_RGB } from "./palette";

/**
 * The panel's theme.
 *
 * Built in two passes because the component overrides need to read palette and
 * typography values (`theme.palette.grey[300]`) rather than repeat their
 * hexes: the first `createTheme` produces those, the second folds the
 * overrides in.
 *
 * The old theme was 40 lines inside `src/index.js` - a font stack and seven
 * colours - so every other decision was made by MUI's defaults or inline in a
 * screen. Anything that should look the same on two pages belongs here.
 */
const base = createTheme({
  palette: palette as any,
  typography: typography as any,
  shape: { borderRadius: 8 },
  spacing: 8,
});

const theme = createTheme(base, {
  components: componentOverrides(base),
});

/** Height of the fixed top bar. Layout maths reads it from here. */
export const HEADER_HEIGHT = 64;

/** Width of the left navigation. Was `15vw`, which shrank the menu on a laptop. */
export const SIDEBAR_WIDTH = 260;

export default theme;
